import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import logo from '../../assets/appantechlogo_version1.png'
import RegisterLoginIcon from "../../assets/Icons/RegisterLoginIcon.svg"

function SideHeader() {
  const location = useLocation();
  const navigate = useNavigate();

  const isForgotPassword = location.pathname === '/auth/forgot-password' || location.pathname === '/auth/set-password';  

  return (
    <div className='side-header-container text-white p-5'>
      <img src={logo} alt='Appan Tech Logo' className='logo' style={{width: "13.7rem"}} />
      <h2 className='fw-bold welcome-header' style={{marginTop: "10px"}}>Welcome back!</h2>
      <p className='side-header-para' style={{textAlign: 'center'}}>{isForgotPassword ? "Reset your password and regain access to your account." : "Your messaging journey starts here. Login to connect."}</p>
      {isForgotPassword ? 
        <div className='login-btn-container'>
          <button className='btn btn-outline-light sideHeader-btn' onClick={() => navigate('/auth/login') }>
            <span className='sideHeader-text'>Login Now</span>
          </button>
          <span className='login-icon'>
            <img src={RegisterLoginIcon} alt="Register Icon" />
          </span>
        </div> 
      : 
     ""
      }
    </div>
  )
}

export default SideHeader
